import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { UPDATE_INBOX_READ_FLAG_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import { INBOX_MESSAGES_TAGS } from './getInboxMessage';
import { INBOX_MESSAGES_UNREAD_COUNT_TAGS } from './getInboxMessageUnreadCount';
import type { UpdateInboxMessageReadFlagPayload } from '../types/updateInboxMessageReadFlag.types';

export const updateInboxMessageReadFlag = (builder: BuilderType) =>
  builder.mutation<void, UpdateInboxMessageReadFlagPayload>({
    invalidatesTags: [INBOX_MESSAGES_TAGS, INBOX_MESSAGES_UNREAD_COUNT_TAGS],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: UPDATE_INBOX_READ_FLAG_URL,
    }),
    transformResponse: (response: GenericApiResponse<void>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
